import { Box, Button, Modal, Stack, Typography } from "@mui/material"
import { SaveStyle } from "./modalBoxStyle"
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import { LoadingButton } from "@mui/lab";

export const CustomModal = ({ openAlertModal, setOpenAlertModal, onSuccess, onError, message, isLoading }: { openAlertModal: boolean, setOpenAlertModal: React.Dispatch<React.SetStateAction<boolean>>, onSuccess: () => void, onError: () => void, message: string, isLoading?: boolean }) => {

    return <Modal
        open={openAlertModal}
        onClose={onError}
    >
        <Box sx={{ ...SaveStyle, width: 200, textAlign: 'center' }}>
            <Stack spacing={2} alignItems='center' justifyContent={'center'}>
                <NotificationImportantIcon sx={{ width: '60px', height: '60px', color: 'red' }} />
                <Typography sx={{ margin: '0 0px 10px', padding: '0px' }}>{message}</Typography>
                <Box sx={{ display: 'flex', gap: '10px' }}>
                    <LoadingButton loading={isLoading ?? false} onClick={onSuccess} variant='contained' sx={{ backgroundColor: '#3150A1', color: 'white', width: '50%' }}>Confirm</LoadingButton>
                    <Button onClick={onError} variant='contained' sx={{ backgroundColor: 'red', color: 'white', width: '50%' }} color="error" > Cancel</Button>
                </Box>
            </Stack>
        </Box >
    </Modal >
}